import React from 'react';

import { toRiskDescription, toScoreText } from './utils';
import { RiskCell, RiskDescription, RiskScore, RiskSide } from './styles';

interface RiskColumnProps {
	side: string;
	score: number;
	risk: string;
}

export function RiskColumn({ side, score, risk }: Readonly<RiskColumnProps>): JSX.Element {
	return (
		<RiskCell>
			<RiskSide>{side}</RiskSide>
			<RiskScore>{toScoreText(score)}</RiskScore>
			<RiskDescription>{toRiskDescription(risk)}</RiskDescription>
		</RiskCell>
	);
}
